/**
 * DGUI component registry — allowlisted component name → React component.
 * Table, List, NeutralBar, BarGraph, LineGraph, PieChart, HeatMap.
 */

import type { ComponentType } from 'react';
import { BarGraph } from './BarGraph';
import { HeatMap } from './HeatMap';
import { InfoCard } from './InfoCard';
import { LineGraph } from './LineGraph';
import { List } from './List';
import { NeutralBar } from './NeutralBar';
import { PieChart } from './PieChart';
import { Table } from './Table';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ALLOWLIST: Record<string, ComponentType<any>> = {
  InfoCard,
  Table,
  List,
  NeutralBar,
  BarGraph,
  LineGraph,
  PieChart,
  HeatMap,
};

/**
 * Returns the DGUI component for the given name, or null if not allowlisted.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getDGUIComponent(name: string): ComponentType<any> | null {
  return ALLOWLIST[name] ?? null;
}
